import jsUtils from '@pernod-ricard-global-cms/jsutils';
import Vue from 'vue';
import personalisationOverlay from 'Templates/blocks/personalisationOverlay/personalisationOverlay.vue';
import Vuex from 'vuex';
import store from 'Assets/js/Vuex/Store/store';

export default function personalisationoverlay() {
  try {
    const options = document.getElementById('personalisationModalOverlay');
    if (options) {
      // eslint-disable-next-line import/no-dynamic-require
      import('Assets/scss/components/blocks/personalisation-overlay.scss');

      jsUtils.loadCss(options.dataset.assetkey, options).then(() => {
        const mountElement = options.children[0];
        // Guard against double-initialisation (lazyloader + direct call)
        if (mountElement && mountElement.__vue__) {
          return;
        }
        Vue.use(Vuex);
        new Vue({
          name: 'PersonalisationOverlay',
          data: { ...mountElement?.dataset, options },
          render: (h) => h(personalisationOverlay),
          store
        }).$mount(mountElement);
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
